var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 5,
    fill: "#FEF5EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5139 19.6042L32.5243 16.4549C32.3472 16.1736 32.0313 16 31.6945 16H19.3056C18.9688 16 18.6528 16.1736 18.4757 16.4549L16.4827 19.6042C15.4549 21.2292 16.3646 23.4896 18.2847 23.75C18.4236 23.7674 18.566 23.7778 18.7049 23.7778C19.6111 23.7778 20.4167 23.3819 20.9688 22.7708C21.5209 23.3819 22.3264 23.7778 23.2327 23.7778C24.1389 23.7778 24.9445 23.3819 25.4965 22.7708C26.0486 23.3819 26.8542 23.7778 27.7604 23.7778C28.6702 23.7778 29.4722 23.3819 30.0243 22.7708C30.5799 23.3819 31.382 23.7778 32.2882 23.7778C32.4306 23.7778 32.5695 23.7674 32.7084 23.75C34.6354 23.4931 35.5486 21.2326 34.5174 19.6042H34.5139ZM32.8507 24.8507H32.8472C32.6632 24.875 32.4757 24.8889 32.2847 24.8889C31.8542 24.8889 31.441 24.8229 31.0556 24.7049V29.3333H19.9445V24.7014C19.5556 24.8229 19.1389 24.8889 18.7084 24.8889C18.5174 24.8889 18.3264 24.875 18.1424 24.8507H18.1389C17.9965 24.8299 17.8577 24.8056 17.7222 24.7708V29.3333V31.5556C17.7222 32.7812 18.7188 33.7778 19.9445 33.7778H31.0556C32.2813 33.7778 33.2778 32.7812 33.2778 31.5556V29.3333V24.7708C33.1389 24.8056 33 24.8333 32.8507 24.8507Z",
    fill: "#DB3F40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17.7778,
    fill: "white",
    transform: "translate(15.5 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.6e716d58eff1a639ee54729bdd39c579.svg";
export { ForwardRef as ReactComponent };